/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Csv_To_Json_Ex_IntroInputs */

const en_csv_to_json_ex_intro = /** @type {(inputs: Csv_To_Json_Ex_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A file with an embedded comma, an escaped quote, and a value that looks like a number.`)
};

const ko_csv_to_json_ex_intro = /** @type {(inputs: Csv_To_Json_Ex_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`쉼표가 들어간 값, 이스케이프된 따옴표, 그리고 숫자처럼 보이는 값이 있는 파일입니다.`)
};

const ja_csv_to_json_ex_intro = /** @type {(inputs: Csv_To_Json_Ex_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カンマを含む値、エスケープされた引用符、数値に見える値があるファイルです。`)
};

/**
* | output |
* | --- |
* | "A file with an embedded comma, an escaped quote, and a value that looks like a number." |
*
* @param {Csv_To_Json_Ex_IntroInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const csv_to_json_ex_intro = /** @type {((inputs?: Csv_To_Json_Ex_IntroInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Csv_To_Json_Ex_IntroInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_csv_to_json_ex_intro(inputs)
	if (locale === "ko") return ko_csv_to_json_ex_intro(inputs)
	return ja_csv_to_json_ex_intro(inputs)
});